// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dCoordinates from "../Data.Coordinates/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Restaumatic$dGeocoding$dTypes$dStreetAddress from "../Restaumatic.Geocoding.Types.StreetAddress/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble$dGeneric from "../Unscramble.Generic/index.js";
const $FindAddressResult = (tag, _1) => ({tag, _1});
const NetworkErrorIsSymbol = {reflectSymbol: () => "NetworkError"};
const streetAddressIsSymbol = {reflectSymbol: () => "streetAddress"};
const AddressDoesNotExistOrInaccurateIsSymbol = {reflectSymbol: () => "AddressDoesNotExistOrInaccurate"};
const coordinatesIsSymbol = {reflectSymbol: () => "coordinates"};
const RestaurantDoesntDeliverToIsSymbol = {reflectSymbol: () => "RestaurantDoesntDeliverTo"};
const ChooseRestaurantIsSymbol = {reflectSymbol: () => "ChooseRestaurant"};
const ChangeRestaurantIsSymbol = {reflectSymbol: () => "ChangeRestaurant"};
const RestaurantDeliversIsSymbol = {reflectSymbol: () => "RestaurantDelivers"};
const decodeRecordCons = /* #__PURE__ */ Unscramble.decodeRecordCons(streetAddressIsSymbol)(Restaumatic$dGeocoding$dTypes$dStreetAddress.unscrambleDecodeStreetAddress)(Unscramble.decodeRecordNil);
const encodeRecordCons1 = /* #__PURE__ */ Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(streetAddressIsSymbol)({
  encodeWithOptions: v => Restaumatic$dGeocoding$dTypes$dStreetAddress.encodeStreetAddress.encode
});
const decodeRecordCons2 = /* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(streetAddressIsSymbol)({
  decodeWithOptions: v => Restaumatic$dGeocoding$dTypes$dStreetAddress.decodeStreetAddress.decode
})();
const NetworkError = /* #__PURE__ */ $FindAddressResult("NetworkError");
const AddressDoesNotExistOrInaccurate = value0 => $FindAddressResult("AddressDoesNotExistOrInaccurate", value0);
const RestaurantDoesntDeliverTo = value0 => $FindAddressResult("RestaurantDoesntDeliverTo", value0);
const ChooseRestaurant = /* #__PURE__ */ $FindAddressResult("ChooseRestaurant");
const ChangeRestaurant = /* #__PURE__ */ $FindAddressResult("ChangeRestaurant");
const RestaurantDelivers = /* #__PURE__ */ $FindAddressResult("RestaurantDelivers");
const toFillFormTypeFindAddress = {fillFormDataType: v => "unknown"};
const eqFindAddressResult = {
  eq: x => y => {
    if (x.tag === "NetworkError") { return y.tag === "NetworkError"; }
    if (x.tag === "AddressDoesNotExistOrInaccurate") {
      if (y.tag === "AddressDoesNotExistOrInaccurate") {
        return x._1.streetAddress.city === y._1.streetAddress.city && x._1.streetAddress.street === y._1.streetAddress.street && x._1.streetAddress.streetNumber === y._1.streetAddress.streetNumber;
      }
      return false;
    }
    if (x.tag === "RestaurantDoesntDeliverTo") {
      if (y.tag === "RestaurantDoesntDeliverTo") {
        return x._1.coordinates.lat === y._1.coordinates.lat && x._1.coordinates.lon === y._1.coordinates.lon && x._1.streetAddress.city === y._1.streetAddress.city && x._1.streetAddress.street === y._1.streetAddress.street && x._1.streetAddress.streetNumber === y._1.streetAddress.streetNumber;
      }
      return false;
    }
    if (x.tag === "ChooseRestaurant") { return y.tag === "ChooseRestaurant"; }
    if (x.tag === "ChangeRestaurant") { return y.tag === "ChangeRestaurant"; }
    if (x.tag === "RestaurantDelivers") { return y.tag === "RestaurantDelivers"; }
    return false;
  }
};
const genericFindAddressResult = {
  to: x => {
    if (x.tag === "Inl") { return NetworkError; }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return $FindAddressResult("AddressDoesNotExistOrInaccurate", x._1._1); }
      if (x._1.tag === "Inr") {
        if (x._1._1.tag === "Inl") { return $FindAddressResult("RestaurantDoesntDeliverTo", x._1._1._1); }
        if (x._1._1.tag === "Inr") {
          if (x._1._1._1.tag === "Inl") { return ChooseRestaurant; }
          if (x._1._1._1.tag === "Inr") {
            if (x._1._1._1._1.tag === "Inl") { return ChangeRestaurant; }
            if (x._1._1._1._1.tag === "Inr") { return RestaurantDelivers; }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "NetworkError") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "AddressDoesNotExistOrInaccurate") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)); }
    if (x.tag === "RestaurantDoesntDeliverTo") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1))); }
    if (x.tag === "ChooseRestaurant") {
      return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))));
    }
    if (x.tag === "ChangeRestaurant") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
      );
    }
    if (x.tag === "RestaurantDelivers") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments))))
      );
    }
    $runtime.fail();
  }
};
const showFindAddressResult = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(NetworkErrorIsSymbol);
    const $1 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => ["{ streetAddress: " + Restaumatic$dGeocoding$dTypes$dStreetAddress.showStreetAddress.show(v.streetAddress) + " }"]
    })(AddressDoesNotExistOrInaccurateIsSymbol);
    const $2 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        "{ coordinates: " + Data$dCoordinates.showCoordinates.show(v.coordinates) + ", streetAddress: " + Restaumatic$dGeocoding$dTypes$dStreetAddress.showStreetAddress.show(v.streetAddress) + " " + "}"
      ]
    })(RestaurantDoesntDeliverToIsSymbol);
    const $3 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(ChooseRestaurantIsSymbol);
    const $4 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(ChangeRestaurantIsSymbol);
    const $5 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(RestaurantDeliversIsSymbol);
    return x => {
      const $6 = genericFindAddressResult.from(x);
      if ($6.tag === "Inl") { return $0["genericShow'"]($6._1); }
      if ($6.tag === "Inr") {
        if ($6._1.tag === "Inl") { return $1["genericShow'"]($6._1._1); }
        if ($6._1.tag === "Inr") {
          if ($6._1._1.tag === "Inl") { return $2["genericShow'"]($6._1._1._1); }
          if ($6._1._1.tag === "Inr") {
            if ($6._1._1._1.tag === "Inl") { return $3["genericShow'"]($6._1._1._1._1); }
            if ($6._1._1._1.tag === "Inr") {
              if ($6._1._1._1._1.tag === "Inl") { return $4["genericShow'"]($6._1._1._1._1._1); }
              if ($6._1._1._1._1.tag === "Inr") { return $5["genericShow'"]($6._1._1._1._1._1); }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeFindAddressResult = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Unscramble$dGeneric.genericDecodeTaggedSumType(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(NetworkErrorIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(AddressDoesNotExistOrInaccurateIsSymbol)({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(decodeRecordCons.recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(RestaurantDoesntDeliverToIsSymbol)({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons(coordinatesIsSymbol)(Data$dCoordinates.unscrambleDecodeCoordinates)(decodeRecordCons).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(ChooseRestaurantIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(ChangeRestaurantIsSymbol))(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(RestaurantDeliversIsSymbol)))))))(Unscramble$dGeneric.defaultOptions);
    return x => genericFindAddressResult.to($0(x));
  })()
};
const encodeFindAddressResult = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericFindAddressResult)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor(NetworkErrorIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor(AddressDoesNotExistOrInaccurateIsSymbol)({
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", encodeRecordCons1.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    });
    const $2 = Foreign$dGeneric$dClass.genericEncodeConstructor(RestaurantDoesntDeliverToIsSymbol)((() => {
      const $2 = Foreign$dGeneric$dClass.encodeRecordCons()(encodeRecordCons1)(coordinatesIsSymbol)({encodeWithOptions: v => Data$dCoordinates.encodeCoordinates.encode});
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $2.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $3 = Foreign$dGeneric$dClass.genericEncodeConstructor(ChooseRestaurantIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $4 = Foreign$dGeneric$dClass.genericEncodeConstructor(ChangeRestaurantIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $5 = Foreign$dGeneric$dClass.genericEncodeConstructor(RestaurantDeliversIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    return {
      encodeOpts: v => v1 => {
        if (v1.tag === "Inl") { return $0.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1); }
        if (v1.tag === "Inr") {
          if (v1._1.tag === "Inl") { return $1.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1); }
          if (v1._1.tag === "Inr") {
            if (v1._1._1.tag === "Inl") { return $2.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1); }
            if (v1._1._1.tag === "Inr") {
              if (v1._1._1._1.tag === "Inl") { return $3.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1); }
              if (v1._1._1._1.tag === "Inr") {
                if (v1._1._1._1._1.tag === "Inl") { return $4.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1); }
                if (v1._1._1._1._1.tag === "Inr") { return $5.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1); }
                $runtime.fail();
              }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
    };
  })())
};
const decodeFindAddressResult = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericFindAddressResult)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(NetworkErrorIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(AddressDoesNotExistOrInaccurateIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(decodeRecordCons2)))(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(RestaurantDoesntDeliverToIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(decodeRecordCons2)(coordinatesIsSymbol)({
    decodeWithOptions: v => Data$dCoordinates.decodeCoordinates.decode
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ChooseRestaurantIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ChangeRestaurantIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(RestaurantDeliversIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments)))))))
};
export {
  $FindAddressResult,
  AddressDoesNotExistOrInaccurate,
  AddressDoesNotExistOrInaccurateIsSymbol,
  ChangeRestaurant,
  ChangeRestaurantIsSymbol,
  ChooseRestaurant,
  ChooseRestaurantIsSymbol,
  NetworkError,
  NetworkErrorIsSymbol,
  RestaurantDelivers,
  RestaurantDeliversIsSymbol,
  RestaurantDoesntDeliverTo,
  RestaurantDoesntDeliverToIsSymbol,
  coordinatesIsSymbol,
  decodeFindAddressResult,
  decodeRecordCons,
  decodeRecordCons2,
  encodeFindAddressResult,
  encodeRecordCons1,
  eqFindAddressResult,
  genericFindAddressResult,
  showFindAddressResult,
  streetAddressIsSymbol,
  toFillFormTypeFindAddress,
  unscrambleDecodeFindAddressResult
};
